import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url, data) =>
  await AxiosConfig.create('post', url).call(data).getResponseData();

const useFetchOrCreateBlankSavDraft = (data) => {
  const {
    data: response,
    error,
    isLoading,
    isValidating,
    mutate,
  } = useSWR(`/savdraft/fetchOrCreateBlank`, (url) => fetcher(url, data), {
    revalidateOnFocus: false,
  });

  return {
    data: response,
    isLoading,
    isValidating,
    error,
    mutate,
  };
};

export default useFetchOrCreateBlankSavDraft;
